// utils
import get from "../../../utils/get";

// constants
import {
  HOTEL_SERVICE_TYPE_INTL_MESSAGES,
  HOTEL_SERVICE_TYPE_VALUE_OTHER,
} from "../../../constants/hotel/service";

/**
 * Retourne le nom du service
 */
export default function hotelServiceGetIntlDisplayName({
  intl,
  hotelService,
  fallback,
}) {
  const type = get(hotelService, "type");

  if (HOTEL_SERVICE_TYPE_VALUE_OTHER === type) {
    return get(hotelService, "name", fallback);
  }

  return get(
    HOTEL_SERVICE_TYPE_INTL_MESSAGES.byValue,
    `${get(hotelService, "type")}.label`,
  )
    ? intl.formatMessage(
        get(
          HOTEL_SERVICE_TYPE_INTL_MESSAGES.byValue,
          `${get(hotelService, "type")}.label`,
        ),
      )
    : fallback;
}
